import { Suspense } from 'react'

import { CentrifugeProvider } from './components/Centrifuge'
import { Loader } from './components/Loader'
import {
  CountersProvider,
  InitProvider,
  MinimizedModalsProvider,
  RouterProvider,
  ScreenProvider,
  SubMenuProvider,
  ThemeModeProvider,
  ThemeProvider,
} from './providers'

function App() {
  return (
    <Suspense fallback={<Loader />}>
      <ThemeModeProvider>
        <InitProvider>
          <ThemeProvider>
            <ScreenProvider>
              <CentrifugeProvider>
                <MinimizedModalsProvider>
                  <SubMenuProvider>
                    <CountersProvider>
                      <RouterProvider />
                    </CountersProvider>
                  </SubMenuProvider>
                </MinimizedModalsProvider>
              </CentrifugeProvider>
            </ScreenProvider>
          </ThemeProvider>
        </InitProvider>
      </ThemeModeProvider>
    </Suspense>
  )
}

export default App
